import {Singleton} from 'app/utils';
import { Application } from 'app/classes';

interface IConstants {
    env: string;
    version: string;
    buildUrl: string;
    platformDomain: string;
    hardcodedLaunchpad: any;
    apps: Array<any>;
    raven: {
        dsn: string;
    };
    intercom: string;
    ga: {
        domain: string;
        appId: string;
    };
    launchdarkly: string;
    cdnAssets: string;
    appIcons: string;
    emailTemplates: string;
}

export let $Constants: IConstants = Singleton('$Constants', Object);
